const removeLocationFromError = (str) => (str.includes('|') ? str.split('|')[0].trim() : str)

export const extractErrorMessage = (err, fallback = 'Operation failed', prefix = '', removeErrorLocation = false) => {
  if (!err) return `${prefix}${fallback}`

  if (typeof err === 'string') {
    return `${prefix}${removeErrorLocation ? removeLocationFromError(err) : err}`
  }

  const message = err.message || err.response?.data?.error
  if (typeof message === 'string') {
    return `${prefix}${removeErrorLocation ? removeLocationFromError(message) : message}`
  }

  return `${prefix}${fallback}`
}

export const success = (message, data = null) => ({ success: true, message, data })

export const failure = (message) => ({ success: false, message })

export function toQueryError(err, fallback = 'Request failed') {
  if (err instanceof Error) return err
  const message = (typeof err === 'string' && err) || err?.message || err?.response?.data?.error || fallback
  return new Error(message)
}
